var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.professional.status === 1
        ? [
            _c("hr"),
            _vm._v(" "),
            _c("h3", { staticClass: "text-body" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.professional.about_your_cleaner")) +
                  "\n      " +
                  _vm._s(_vm._f("firstName")(_vm.professional.name)) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _vm.professional.short_description
              ? _c("div", { staticClass: "professional-short-description" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.professional.short_description) +
                      "\n    "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "mb-1 text-long" }, [
              _vm.$i18n.locale === "th"
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("stripSlashes")(_vm.professional.description)
                      )
                    )
                  ])
                : _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("stripSlashes")(_vm.professional.description_en)
                      )
                    )
                  ])
            ]),
            _vm._v(" "),
            _vm.professional.service_ids.indexOf(16) === -1
              ? [
                  _c("hr"),
                  _vm._v(" "),
                  _c("h3", { staticClass: "text-body" }, [
                    _vm._v(_vm._s(_vm.$t("message.professional.my_services")))
                  ]),
                  _vm._v(" "),
                  _c("div", {}, [
                    _vm.professional.service_ids.includes(1)
                      ? _c("div", { staticClass: "cleaner-equipment" }, [
                          _c("img", {
                            attrs: { src: "/static/img/ic-cleaning.svg" }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.serviceParentName(
                                  1,
                                  _vm.globalState.services
                                )
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.professional.service_ids.includes(2)
                      ? _c("div", { staticClass: "cleaner-equipment" }, [
                          _c("img", {
                            attrs: { src: "/static/img/ic-ironing.svg" }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.serviceParentName(
                                  2,
                                  _vm.globalState.services
                                )
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.professional.service_ids.includes(39)
                      ? _c("div", { staticClass: "cleaner-equipment" }, [
                          _c("img", {
                            attrs: { src: "/static/img/ic-bathroom.svg" }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.serviceParentName(
                                  39,
                                  _vm.globalState.services
                                )
                              )
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.professional.professional_districts &&
            _vm.professional.professional_districts.length > 0
              ? [
                  _c("hr"),
                  _vm._v(" "),
                  _c("h3", { staticClass: "text-body" }, [
                    _vm._v(_vm._s(_vm.$t("message.professional.service_areas")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 p-0" },
                      _vm._l(_vm.professional.professional_districts, function(
                        districtData,
                        index
                      ) {
                        return _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("multiLangName")(districtData.district)
                              ) +
                              _vm._s(
                                index + 1 ===
                                  _vm.professional.professional_districts.length
                                  ? ""
                                  : ", "
                              ) +
                              "\n          "
                          )
                        ])
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "card mt-3 rounded-all",
                      staticStyle: { "background-color": "#FDF8E0" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "card-body p-2 d-flex justify-content-start align-items-top"
                        },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("div", { staticClass: "pl-2" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "message.professional.service_areas_remark"
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.getPetTypes()
                    ? _c(
                        "div",
                        {
                          staticClass: "card mt-3 rounded-all",
                          staticStyle: { "background-color": "#FDF8E0" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "card-body p-2 d-flex justify-content-start align-items-top"
                            },
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _c("div", { staticClass: "pl-2" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.professional.inconvenient_pet"
                                      )
                                    )
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.getPetTypes()))
                                ])
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.professional.transportation_type
              ? [
                  _c("hr"),
                  _vm._v(" "),
                  _c("h3", { staticClass: "text-body" }, [
                    _vm._v(
                      _vm._s(_vm.$t("message.professional.transportation_type"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$options.filters.transportationTypeIcon(
                          _vm.professional.transportation_type
                        )
                      )
                    }
                  }),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("multiLangName")(
                          _vm.professional.transportation_type
                        )
                      ) +
                      "\n    "
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h3", { staticClass: "text-body" }, [
              _vm._v(_vm._s(_vm.$t("message.professional.spoken_languages")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 p-0" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.professional.spoken_languages) +
                    "\n      "
                )
              ])
            ]),
            _vm._v(" "),
            _vm.professional.service_ids.indexOf(1) !== -1
              ? [
                  _c("hr"),
                  _vm._v(" "),
                  _c("h3", { staticClass: "text-body" }, [
                    _vm._v(
                      _vm._s(_vm.$t("message.professional.what_i_will_provide"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex flex-row" }, [
                    _vm.professional.has_vacuum_cleaner
                      ? _c("div", { staticClass: "cleaner-equipment" }, [
                          _c("img", {
                            attrs: { src: "/static/img/ic-vacuum.svg" }
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("message.professional.vacuum_cleaner")
                              ) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "cleaner-equipment" }, [
                      _c("img", {
                        attrs: { src: "/static/img/ic-cleaning-equipment.svg" }
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("message.professional.cleaning_equipment")
                          ) +
                          "\n        "
                      )
                    ])
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.professional.service_ids.indexOf(1) !== -1 ||
            _vm.professional.service_ids.indexOf(1) !== -16
              ? [
                  _c("hr"),
                  _vm._v(" "),
                  _c("h3", { staticClass: "text-body" }, [
                    _vm._v(
                      _vm._s(_vm.$t("message.professional.cleaning_skills"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("cleaner-skills")
                ]
              : _vm._e()
          ]
        : [
            _c("div", { staticClass: "space-top-16 text-center" }, [
              _c("h3", [
                _c("i", {
                  staticClass: "fas fa-exclamation-triangle text-orange"
                }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.professional.not_available")) +
                    "\n      "
                )
              ])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "fal fa-exclamation-circle text-danger" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          id: "badge-inconvenient-pet",
          src: "/static/img/badge-inconvenient-pet.svg",
          alt: "",
          width: "24"
        }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bda09e64", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bda09e64","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/components/CleanerDescriptionSection.vue
// module id = 1737
// module chunks = 0